import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosPublic from "../../api/axiosPublic";

export const signupWithoutKycApi = createAsyncThunk(
  "customers-api/registrations/without-kyc",
  async (signupPayload, { rejectWithValue }) => {
    try {
      const { data } = await axiosPublic.post(
        `customers-api/registrations/without-kyc`,
        signupPayload
      );

      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
